import React from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";

interface LeaveCalendarProps {
    selectedDates: { date: Date; isHalfDay: boolean }[];
    onDateClick: (date: Date) => void;
}

const LeaveCalendar: React.FC<LeaveCalendarProps> = ({ selectedDates, onDateClick }) => {
    const today = new Date();

    return (
        <div className="p-4 border-[1px] border-solid border-surface-border bg-white responsive-datepicker applyLeave-blog">
            <h2 className="font-semibold mb-2 mt-0">Select Leave Dates</h2>
            <DayPicker
                mode="multiple"
                selected={selectedDates.map(item => item.date)}
                onDayClick={onDateClick}
                defaultMonth={today}        // Start at current month
                fromMonth={today}           // Can't go to past months
                disabled={{ before: today }} // Can't select past dates
            />
        </div>
    );
};

export default LeaveCalendar;
